import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';


declare global {
  interface Window {
    elementHasEllipsis: (element: HTMLElement) => boolean;
  }
}

(window as Window & typeof globalThis).elementHasEllipsis = (element: HTMLElement) => {
  return element.offsetWidth < element.scrollWidth;
};

bootstrapApplication(AppComponent, appConfig)
  .catch(() => {});
